// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__4PIAN","content":"RecentSearches_content__OpAiB"};